import http from "./axios";

export default {
  async login() {
    try {
      return await http.post(`/api/anonymous/login`);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
